import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMediaQuery, useTheme } from '@mui/material';
import Flex from 'components/Flex/Flex';
import Header from 'components/Header';
const MainLayout = ({ children }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const isTablet = useMediaQuery(theme.breakpoints.between('md', 'lg'));
    const maxWidth = isMobile ? '90vw' : isTablet ? '70vw' : '50vw';
    const padding = isMobile ? '2rem 1rem' : '3rem 1rem';
    return (_jsxs("div", { style: { display: 'flex', flexDirection: 'column', minHeight: '100vh' }, children: [_jsx(Header, {}), _jsx(Flex, { justifyContent: "center", alignItems: "center", style: {
                    flexGrow: 1,
                }, children: _jsx(Flex, { column: true, alignItems: "center", gap: "2rem", style: {
                        position: 'relative',
                        backgroundColor: 'rgba(19, 19, 22, 0.80)',
                        zIndex: 1,
                        opacity: 1,
                        width: '100%',
                        maxWidth,
                        borderRadius: '1.25rem',
                        border: '1px solid rgba(186, 186, 186, 0.10)',
                        boxShadow: '20px 40px 60px 0px rgba(0, 0, 0, 0.50)',
                        padding,
                        backdropFilter: 'blur(50px)',
                    }, children: children }) })] }));
};
export default MainLayout;
